import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-cream-dark py-4">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center text-left focus:outline-none"
      >
        <span className="font-medium text-botanical-dark">{question}</span>
        <SafeIcon icon={isOpen ? FiIcons.FiMinus : FiIcons.FiPlus} className="text-clay shrink-0 ml-4" />
      </button>
      {isOpen && (
        <div className="mt-4 text-gray-600 text-sm leading-relaxed pr-8">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const faqs = [
    {
      q: "How do I know when to water my plant?",
      a: "The golden rule is to always check the soil before watering. Stick your finger about 2 inches into the soil. If it feels dry, it's time to water. If it's still damp, wait a few more days. Overwatering is the most common cause of plant demise!"
    },
    {
      q: "My plant arrived with a damaged leaf. What should I do?",
      a: "Don't panic! It's completely normal for a plant to lose a leaf or two while adjusting to a new environment or after shipping. Simply snip off the yellowing or damaged leaf near the base of the stem. If the plant suffered severe damage, refer to our guarantee policy."
    },
    {
      q: "Do you ship during the winter?",
      a: "Yes, we ship year-round! During colder months, we include complimentary heat packs in your order to ensure your tropical plants stay cozy during transit to colder regions."
    },
    {
      q: "Are your pots drainage-friendly?",
      a: "All our nursery pots have drainage holes. For our decorative ceramic and terracotta accessories, please check the specific product description, though we highly recommend keeping plants in their nursery pots and placing them inside the decorative ones."
    }
  ];

  return (
    <div className="min-h-screen bg-cream py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-serif text-botanical-dark mb-4">Care & Support</h1>
          <p className="text-gray-600">Everything you need to know about shipping, returns, and keeping your green friends alive.</p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm mb-12">
          <h2 className="font-serif text-2xl text-botanical-dark mb-6 flex items-center gap-3">
            <SafeIcon icon={FiIcons.FiHelpCircle} className="text-clay" /> Frequently Asked Questions
          </h2>
          <div className="space-y-2">
            {faqs.map((faq, idx) => (
              <FAQItem key={idx} question={faq.q} answer={faq.a} />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-botanical/5 rounded-3xl p-8 border border-botanical/10">
            <h3 className="font-serif text-xl text-botanical-dark mb-4 flex items-center gap-2">
               <SafeIcon icon={FiIcons.FiTruck} className="text-botanical" /> Shipping Policy
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Orders are processed within 1-3 business days. We ship via standard ground, which typically takes 3-5 business days depending on your location. We carefully package each plant to minimize movement and stress during transit. Shipping is free on all orders over $50.
            </p>
          </div>

          <div className="bg-clay/5 rounded-3xl p-8 border border-clay/10">
            <h3 className="font-serif text-xl text-botanical-dark mb-4 flex items-center gap-2">
               <SafeIcon icon={FiIcons.FiRefreshCw} className="text-clay" /> Returns & Guarantee
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              We guarantee your plant arrives happy and healthy. If it is significantly damaged in transit, please contact us with photos within 14 days of delivery, and we will issue a replacement. Due to the perishable nature of plants, we do not accept general returns.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FAQ;